// deps
import React, { ReactElement, memo } from "react";

interface OneLogoProps {
    width?: number;
    height?: number;
    className?: string;
}

const OneLogoV4 = (props: OneLogoProps): ReactElement => {
    const { height = 104, width = 104, className = "" } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M36.8724 53.8083C36.8724 46.07 40.644 39.8086 47.4451 37.9167L34.5972 26.114L45.8634 9.78296C19.681 12.3949 4.52148 31.7895 4.52148 53.8083C4.52148 73.508 16.6272 91.2548 37.9065 96.6741L46.6786 69.6511C40.352 67.5151 36.8724 61.4001 36.8724 53.8083Z"
                fill="url(#paint0_linear_13046_46357)"
            />
            <path
                d="M51.9068 70.4926C61.7008 70.4926 67.115 63.3035 67.115 53.8321C67.115 45.2272 62.4795 38.4287 54.0237 37.4644C53.8413 37.44 53.6344 37.4522 53.4398 37.4278L54.2549 44.2019L47.4173 37.9161L34.5694 26.1133L45.8357 9.78231L49.4856 4.52173L50.094 9.52599C50.7023 9.50158 51.2984 9.44056 51.9189 9.44056C81.9947 9.44056 99.478 30.1411 99.478 53.8199C99.478 77.4986 81.9947 98.3822 51.9189 98.3822C30.1165 98.3822 14.9691 87.2752 8.32617 72.0793L40.2634 64.9269C42.8062 68.3566 46.7238 70.4926 51.9068 70.4926Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_13046_46357"
                    x1="32.3564"
                    y1="9.07248"
                    x2="25.0202"
                    y2="64.198"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
            </defs>
        </svg>
    );
};

function OneLogo(props: OneLogoProps): ReactElement {
    return <OneLogoV4 {...props} />;
}

export default memo(OneLogo);
